export default __webpack_public_path__ + "static/media/1040.a8b243d6.png";